import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

const QuantityPicker = ({
  initialValue = 1,
  minValue = 1,
  maxValue = 10,
  onChange
}) => {
  const [quantity, setQuantity] = useState(initialValue);

  const handleIncrement = () => {
    if (quantity < maxValue) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      onChange(newQuantity);
    }
  };

  const handleDecrement = () => {
    if (quantity > minValue) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      onChange(newQuantity);
    }
  };

  const handleInputChange = (e) => {
    const value = Math.max(
      minValue,
      Math.min(maxValue, parseInt(e.target.value, 10) || 0)
    );
    setQuantity(value);
    onChange(value);
  };

  return (
    <div className="quantity-picker pixel-corners-wrapper">
      <Button
        className="quantity-btn decrement"
        onClick={handleDecrement}
        disabled={quantity <= minValue}
      >
        v
      </Button>

      <input
        type="number"
        value={quantity}
        onChange={handleInputChange}
        className="quantity-input"
        min={minValue}
        max={maxValue}
        aria-label="Quantity"
      />

      <Button
        className="quantity-btn increment"
        onClick={handleIncrement}
        disabled={quantity >= maxValue}
      >
        v
      </Button>
    </div>
  );
};

QuantityPicker.propTypes = {
  initialValue: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default QuantityPicker;
